var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "collectionNewDialog",
      style: { left: _vm.left },
      attrs: {
        "append-to-body": true,
        "close-on-click-modal": false,
        visible: _vm.collectionShow,
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.collectionShow = $event
        },
      },
    },
    [
      _c("div", { staticClass: "headerTitle" }, [_vm._v(" 生成操作确认单 ")]),
      _vm.collectionShow
        ? _c("div", { staticClass: "bodyContent" }, [
            _c("p", [_vm._v("确认项目及收费金额")]),
            _c("div", [
              _c("div", { staticClass: "selectTags" }, [
                _c("div", { staticClass: "itemTitle" }, [
                  _c("i", { staticClass: "el-icon-circle-plus iconOptions" }),
                  _c("p", { staticStyle: { "margin-left": "10px" } }, [
                    _c("span", { staticStyle: { "font-size": "16px" } }, [
                      _vm._v("价格"),
                    ]),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "margin-left": "5px",
                          "font-size": "12px",
                          color: "rgba(86,127,0,100)",
                        },
                      },
                      [_vm._v("单选")]
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "right" },
                  [
                    _c(
                      "el-radio-group",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          "margin-left": "20px",
                          "margin-top": "5px",
                        },
                        on: { change: _vm.checkboxItemsChange },
                        model: {
                          value: _vm.checkboxItems,
                          callback: function ($$v) {
                            _vm.checkboxItems = $$v
                          },
                          expression: "checkboxItems",
                        },
                      },
                      [
                        _c(
                          "el-radio",
                          {
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: { label: 1 },
                          },
                          [
                            _vm._v(
                              "方案总价" +
                                _vm._s(
                                  _vm.totalPayPrice
                                    ? "(" + _vm.totalPayPrice.toFixed(2) + "¥)"
                                    : ""
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "el-radio",
                          {
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: { label: -1 },
                          },
                          [
                            _vm._v(
                              "单人价格" +
                                _vm._s(
                                  _vm.totalPayPrice
                                    ? "(" +
                                        (
                                          _vm.totalPayPrice /
                                          _vm.checkBudget.useNumber
                                        ).toFixed(2) +
                                        "¥)"
                                    : ""
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "el-radio",
                          {
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: { label: 2 },
                          },
                          [
                            _c("span", [_vm._v("项目总价")]),
                            _vm.checkboxItems === 2 &&
                            _vm.stateTotalPayPrice.filter((x) => x.price > 0)
                              .length
                              ? _c(
                                  "el-checkbox-group",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "flex-wrap": "wrap",
                                      "margin-left": "20px",
                                      "background-color": "white",
                                      padding: "5px",
                                      "border-radius": "5px",
                                      "margin-top": "5px",
                                    },
                                    on: {
                                      change: _vm.projectCheckboxItemsChange,
                                    },
                                    model: {
                                      value: _vm.projectCheckboxItems,
                                      callback: function ($$v) {
                                        _vm.projectCheckboxItems = $$v
                                      },
                                      expression: "projectCheckboxItems",
                                    },
                                  },
                                  _vm._l(
                                    _vm.stateTotalPayPrice.filter(
                                      (x) => x.price > 0
                                    ),
                                    function (itemCheck, itemCheckIndex) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: itemCheckIndex,
                                          staticStyle: {
                                            width: "180px",
                                            "margin-left": "0",
                                            "margin-bottom": "5px",
                                          },
                                          attrs: {
                                            label: itemCheck.state,
                                            border: "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.stockTypeMap[
                                                  itemCheck.state
                                                ].typeName
                                              ) +
                                              "（" +
                                              _vm._s(
                                                itemCheck.price.toFixed(2)
                                              ) +
                                              "¥） "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "el-radio",
                          {
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: { label: 3 },
                          },
                          [
                            _c("span", [_vm._v("按具体产品")]),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "margin-left": "5px",
                                  "font-size": "12px",
                                  color: "rgba(86,127,0,100)",
                                  "font-weight": "400",
                                },
                                on: { click: _vm.chooseProduct },
                              },
                              [_vm._v("选择产品")]
                            ),
                          ]
                        ),
                        _c(
                          "el-radio",
                          {
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: { label: 4 },
                          },
                          [
                            _c("span", [_vm._v("自定义")]),
                            _vm.checkboxItems == 4
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-left": "10px",
                                      "font-size": "0.12rem",
                                    },
                                  },
                                  [_vm._v("必填")]
                                )
                              : _vm._e(),
                            _vm.checkboxItems === 4
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "background-color": "white",
                                      padding: "5px",
                                      "border-radius": "5px",
                                      "margin-top": "5px",
                                      "margin-left": "20px",
                                      width: "93%",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        rows: 4,
                                        placeholder: "请填写你的收款内容",
                                        type: "textarea",
                                      },
                                      model: {
                                        value: _vm.selectRow.chargingContent,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.selectRow,
                                            "chargingContent",
                                            $$v
                                          )
                                        },
                                        expression: "selectRow.chargingContent",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticStyle: { "margin-left": "20px" } },
                      [
                        _c(
                          "el-form",
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "收费金额" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "370px" },
                                  attrs: {
                                    min: 0,
                                    placeholder: "请输入收费金额？",
                                    type: "number",
                                  },
                                  model: {
                                    value: _vm.selectRow.feeAmount,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.selectRow, "feeAmount", $$v)
                                    },
                                    expression: "selectRow.feeAmount",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "币种信息" } },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: "自定义的情况下才能选择币种！",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "370px" },
                                        attrs: {
                                          disabled: _vm.checkboxItems !== 4,
                                        },
                                        on: { change: _vm.currencyChange },
                                        model: {
                                          value: _vm.selectRow.currency,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.selectRow,
                                              "currency",
                                              $$v
                                            )
                                          },
                                          expression: "selectRow.currency",
                                        },
                                      },
                                      _vm._l(
                                        _vm.currencyList,
                                        function (currency, index) {
                                          return _c(
                                            "el-option",
                                            {
                                              key: index,
                                              attrs: {
                                                label: currency.currencyOption,
                                                value: currency.code,
                                              },
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        width: "30px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(currency.code)
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "10px",
                                                        width: "70px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(currency.name)
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "40px",
                                                        width: "70px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " 今日收款汇率： "
                                                      ),
                                                      currency.payeeRate
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                currency.payeeRate
                                                              )
                                                            ),
                                                          ])
                                                        : _c("span", [
                                                            _vm._v("暂无信息"),
                                                          ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.checkboxItems !== 4
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-left": "20px",
                              "background-color": "white",
                              padding: "10px",
                              "border-radius": "5px",
                              width: "93%",
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.selectRow.payOrder,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.selectRow, "payOrder", $$v)
                                  },
                                  expression: "selectRow.payOrder",
                                },
                              },
                              [
                                _c(
                                  "el-radio",
                                  { attrs: { label: 1, border: "" } },
                                  [_vm._v("客人缴费后系统自动下采购订单")]
                                ),
                                _c(
                                  "el-radio",
                                  { attrs: { label: 2, border: "" } },
                                  [
                                    _vm._v(
                                      "客人缴费后，我自己手动下产品采购订单"
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "selectTags" }, [
                _c("div", { staticClass: "itemTitle" }, [
                  _c("i", { staticClass: "el-icon-circle-plus iconOptions" }),
                  _c("p", { staticStyle: { "margin-left": "10px" } }, [
                    _c("span", { staticStyle: { "font-size": "16px" } }, [
                      _vm._v("费用说明"),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "right" },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-left": "20px" },
                        attrs: { "label-position": "top" },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "服务提供方" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "96%" },
                              attrs: { placeholder: "请填写服务提供方？" },
                              model: {
                                value: _vm.selectRow.serviceProvider,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.selectRow,
                                    "serviceProvider",
                                    $$v
                                  )
                                },
                                expression: "selectRow.serviceProvider",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "联系人" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "96%" },
                              attrs: { placeholder: "请填写联系人？" },
                              model: {
                                value: _vm.selectRow.contacts,
                                callback: function ($$v) {
                                  _vm.$set(_vm.selectRow, "contacts", $$v)
                                },
                                expression: "selectRow.contacts",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "发票说明" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "96%" },
                              attrs: {
                                rows: 4,
                                placeholder: "请填写发票说明（非必填）？",
                                type: "textarea",
                              },
                              model: {
                                value: _vm.selectRow.invoiceDescription,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.selectRow,
                                    "invoiceDescription",
                                    $$v
                                  )
                                },
                                expression: "selectRow.invoiceDescription",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.checkboxItems === 4
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "包含" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "96%" },
                                  attrs: {
                                    rows: 4,
                                    placeholder: "请填写包含费用？",
                                    type: "textarea",
                                  },
                                  model: {
                                    value: _vm.selectRow.contain,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.selectRow, "contain", $$v)
                                    },
                                    expression: "selectRow.contain",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.checkboxItems === 4
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "退改" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "96%" },
                                  attrs: {
                                    rows: 4,
                                    placeholder: "请填写退改费用？",
                                    type: "textarea",
                                  },
                                  model: {
                                    value: _vm.selectRow.returnMsg,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.selectRow, "returnMsg", $$v)
                                    },
                                    expression: "selectRow.returnMsg",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.checkboxItems === 4
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "不含" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "96%" },
                                  attrs: {
                                    rows: 4,
                                    placeholder: "请填写不包含费用（非必填）？",
                                    type: "textarea",
                                  },
                                  model: {
                                    value: _vm.selectRow.excluding,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.selectRow, "excluding", $$v)
                                    },
                                    expression: "selectRow.excluding",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "selectTags" }, [
                _c("div", { staticClass: "itemTitle" }, [
                  _c("i", { staticClass: "el-icon-circle-plus iconOptions" }),
                  _c("p", { staticStyle: { "margin-left": "10px" } }, [
                    _c("span", { staticStyle: { "font-size": "16px" } }, [
                      _vm._v("条款"),
                    ]),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "margin-left": "5px",
                          "font-size": "12px",
                          color: "rgba(86,127,0,100)",
                        },
                      },
                      [_vm._v("单选")]
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "text-decoration": "underline",
                          display: "inline-block",
                          transform: "scale(0.8)",
                          "border-radius": "10px",
                          color: "rgb(219, 78, 26)",
                        },
                        attrs: { type: "" },
                        on: { click: _vm.handlerOrganizationSetClick },
                      },
                      [_vm._v("点击新增")]
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "right", staticStyle: { height: "100px" } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        staticStyle: {
                          display: "flex",
                          "margin-left": "20px",
                          "margin-top": "5px",
                        },
                        on: { change: _vm.changeRadio },
                        model: {
                          value: _vm.clauseItems,
                          callback: function ($$v) {
                            _vm.clauseItems = $$v
                          },
                          expression: "clauseItems",
                        },
                      },
                      _vm._l(_vm.schemeData, function (item, index) {
                        return _c(
                          "el-radio",
                          {
                            key: index,
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: { label: item.id },
                            nativeOn: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.changeRadio(item.id)
                              },
                            },
                          },
                          [_vm._v(_vm._s(item.schemeName) + " ")]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "selectTags",
                  staticStyle: { "margin-top": "5px", height: "190px" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "itemTitle" },
                    [
                      _c("svg-icon", {
                        staticClass: "iconExport bigIcon",
                        attrs: { "icon-class": "exportRight" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "right",
                      staticStyle: {
                        "border-left": "none",
                        position: "relative",
                        top: "-92px",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "Item-File",
                          staticStyle: {
                            "margin-left": "20px",
                            "background-color": "white",
                            padding: "10px",
                            "border-radius": "5px",
                            width: "93%",
                          },
                        },
                        [
                          _c("div", [
                            _c(
                              "div",
                              { staticStyle: { position: "relative" } },
                              [
                                !_vm.text
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "background-color":
                                            "rgb(245,241,241,0.9)",
                                          height: "100%",
                                          width: "100%",
                                          position: "absolute",
                                          color: "#2b8bc6",
                                          "font-weight": "700",
                                          display: "flex",
                                          "align-items": "center",
                                          "justify-content": "center",
                                        },
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              "text-align": "center",
                                            },
                                          },
                                          [_vm._v("点击下方按钮生成")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c("Qr", { attrs: { text: _vm.text } }),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "center",
                                  "margin-top": "5px",
                                  "font-weight": "700",
                                },
                              },
                              [_vm._v("扫描查看手机版本")]
                            ),
                          ]),
                          _c(
                            "div",
                            [
                              _c(
                                "el-radio-group",
                                {
                                  staticClass: "Export-Item-Radio-Download",
                                  on: { change: _vm.versionExport },
                                  model: {
                                    value: _vm.itemFileType,
                                    callback: function ($$v) {
                                      _vm.itemFileType = $$v
                                    },
                                    expression: "itemFileType",
                                  },
                                },
                                _vm._l(
                                  _vm.exportContent[0].itemFileTypeArr,
                                  function (item, index) {
                                    return _c(
                                      "el-radio",
                                      {
                                        key: index,
                                        staticStyle: { width: "230px" },
                                        attrs: { label: item.value },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticClass: "icon",
                                            staticStyle: {
                                              position: "relative",
                                              top: "6px",
                                            },
                                            attrs: {
                                              height: "200",
                                              "p-id": "5156",
                                              t: "1728568808301",
                                              version: "1.1",
                                              viewBox: "0 0 1024 1024",
                                              width: "200",
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M833.841473 336.403925c-29.237791-149.914232-160.920736-263.309448-321.841473-263.309448S219.452762 186.489692 190.158527 336.403925C80.48859 365.641715 0 468.030427 0 585.038033c0 142.633006 113.395216 256.028222 255.971778 256.028222h36.57546v-73.15092h-36.57546c-102.388711 0-182.877301-80.432146-182.877301-182.877302 0-102.388711 80.432146-182.877301 182.877301-182.877301 0-142.633006 113.395216-255.971778 255.971778-255.971778 142.633006 0 256.028222 113.395216 256.028222 255.971778 102.388711 0 182.877301 80.432146 182.877301 182.877301 0 102.388711-80.432146 182.877301-182.877301 182.877302h-36.57546v73.15092h36.57546c142.633006 0 255.971778-113.395216 255.971778-256.028222 0.056444-117.007607-80.432146-219.396318-190.102083-248.634108z",
                                                "p-id": "5157",
                                              },
                                            }),
                                            _c("path", {
                                              attrs: {
                                                d: "M599.769816 782.53423l-43.856686 40.244295V511.943556c0-21.956565-18.28773-36.57546-36.575461-36.57546-21.956565 0-36.57546 18.28773-36.57546 36.57546v310.834969l-43.91313-40.244295c-14.618895-14.618895-40.244295-14.618895-54.86319 0-14.618895 14.618895-14.618895 36.57546 0 51.194356l109.726381 106.057546c3.668835 3.668835 7.337669 7.337669 10.950061 7.337669 14.618895 7.337669 29.237791 3.668835 40.244295-7.337669l106.057546-106.057546c14.618895-14.618895 14.618895-36.57546 0-51.194356-10.950061-14.618895-36.57546-14.618895-51.194356 0z",
                                                "p-id": "5158",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("span", {
                                          staticStyle: {
                                            "font-size": "12px !important",
                                            "margin-left": "3px",
                                          },
                                          domProps: {
                                            innerHTML: _vm._s(item.name),
                                          },
                                        }),
                                        _vm.itemFileType === item.value
                                          ? _c(
                                              "span",
                                              { staticClass: "checked" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-loading",
                                                  staticStyle: {
                                                    position: "absolute",
                                                    "font-weight": "700",
                                                    top: "10px",
                                                    left: "-25px",
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }
                                ),
                                1
                              ),
                              _c("mapCanvas", {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "center",
                                  "margin-top": "5px",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "93%",
                            display: "flex",
                            "justify-content": "center",
                            "margin-left": "20px",
                            "margin-top": "20px",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                width: "50%",
                                "border-radius": "20px",
                              },
                              attrs: { type: "primary" },
                              on: { click: _vm.submitForm },
                            },
                            [_vm._v("立即生成 ")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                width: "50%",
                                "border-radius": "20px",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.collectionShow = false
                                },
                              },
                            },
                            [_vm._v("取消生成 ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _c("budget-detail-dialog", {
        ref: "budgetDetailDialog",
        attrs: { chenckBudget: _vm.checkBudget },
        on: { chooseProduct: _vm.chooseProductSure },
      }),
      _c("offerDetailPopup", {
        ref: "offerPopup",
        staticStyle: { "margin-left": "-20px" },
        attrs: { "display-mode": true, "show-button": false },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }